import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "src/store/slices/user.slice";
import branchReducer from "src/store/slices/branch.slice";
import reportReducer from "src/store/slices/report.slice";
import settingsReducer from "src/store/slices/settings.slice";

import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  branch: branchReducer,
  report: reportReducer,
  settings: settingsReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
